import React from "react";

import { useStyles } from "./styles";

export const Spacer = () => {
	const classes = useStyles();
	return <div className={classes.spacer}></div>;
};
